
import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTS, ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";


export const getCustomers = (async(pageNumber,pageSize,searchString,orderByString,filterString,showActiveRowsOnly) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.browse,
    method: 'get',
    params:{
        PageNumber:pageNumber,
        PageSize:pageSize,
        OrderByString:orderByString,
        SearchString:searchString,
        FilterString:filterString,
        getActiveRowsOnly:showActiveRowsOnly
    }
}).then((res) =>{

    return res.data
}).catch((err) =>{
    return Promise.reject(err);
})

)


export const getCustomer = (async (id) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.load,
    method: 'get',
    params: { Id: id }
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})

)
export const getNextCustomerCode = (async () => await http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.nextCode,
    method: 'get',
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})

)
export const getGeographicalClassification = (async (id) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.GeographicalClassification.getId,
    params:{
        id
    },
    method: 'get',
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})

)


export const postCustomer = (data) => http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.browse,
        method: 'post',
    data: data
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})



export const putCustomer = (data) => http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.browse,
        method: 'put',
    data: data
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})
export const importCustomer = (data,organizationId , param ,businessActivityTypeId
) => http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.Import,
    method: 'post',
    data: data,
    params:{
        organizationId,
        businessActivityTypeId,
        ...param

    }
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})

export const deleteCustomer = (id) => http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.browse,
        method: 'DELETE',
    params: {
        id :id
    }
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})

export const getPersonApi = (async (search, id ) => await http({

    url: id.length >1 ?  ENDPOINTS.BaseInformation.person.dictionaryDetailId :  ENDPOINTS.BaseInformation.person.dictionaryDetail,
    method: 'get',
    params: {
        SearchString: search,
        Id: id
    }
})  
    .then((respons) => (respons.data.Data))
)
export const getEditablecolumns = (async () => await http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.getEditableColumns,
    method: 'get',

})  
    .then((respons) => (respons.data.Data))
)
export const putEditableList = (data) => http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.putEditableColumns,
        method: 'put',
    data: data
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})


export const getCustomerPhoneNumbers = (customerPositionId,pageNumber: number, pageSize: number, searchString, orderBy, filterlist) => http({
    url: ENDPOINTS.BaseInformation.CustomerPosition.PhoneNumbers,
    method: 'get',
    params: {
        customerPositionId :customerPositionId,
        PageNumber: pageNumber,
        PageSize: pageSize,
        SearchString: searchString,
        OrderByString: orderBy,
        FilterString: filterlist
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const postCustomerPhoneListApi = (data  ) => http({
    url:  ENDPOINTS.BaseInformation.CustomerPosition.positionContact,
    method: 'post',
    data:data
    
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const deletePersonContact = (id  ) => http({
    url:  ENDPOINTS.BaseInformation.CustomerPosition.brows,
    method: 'delete',
params:{
    id
}
    
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
export const setDefault = (personContactId  ) => http({
    url:  ENDPOINTS.afterSalesApi.SetDefaultContact,
    method: 'put',
params:{
    personContactId
}
    
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});

export const getPerson = (personId: any) => http({
    url: ENDPOINTS.BaseInformation.person.dictionaryDetailId,
    method: 'get',
    headers: { "Accept-Language": "en" },
    params: {
        Id: personId
    }
}).then((res) => {
    return res
}).catch((err) => {
    return Promise.reject( err);
});
